jQuery(function ($) {
    var ppp = 3; // Post per page
    var pageNumber = 2;

    console.log('ajax');

    $('.newsroom-all .read--more').on('click', function () {
        var button = $(this);
        var btnText = button.text();
        button.text('Loading...');

        var classList = button.attr('class').split(' ');
        var theType = classList[0].split('-');
        var postType = theType[1];
        var str =
            '&pageNumber=' +
            pageNumber +
            '&ppp=' +
            ppp +
            '&type=' +
            postType +
            '&action=more_post_ajax';

        $.ajax({
            type: 'POST',
            dataType: 'html',
            url: ajax_posts.ajaxurl,
            data: str,
            beforeSend: function (jqXHR) {
                button.text('Loading...');
            },
            success: function (data) {
                if (data) {
                    $('#newsroom-' + postType + '-posts .newsroom-grid').append(
                        data
                    );
                    button.text(btnText);
                } else {
                    button.hide();
                    $('.media-' + postType + ' .newsroom-all .cell').text(
                        'No more posts'
                    );
                    console.log('No More Items');
                }
            },
            afterSend: function (jqXHR) {
                button.text('More posts').prev().before(data);
            },
            error: function (jqXHR, textStatus, errorThrown) {
                $loader.html(
                    jqXHR + ' :: ' + textStatus + ' :: ' + errorThrown
                );
            }
        });
        pageNumber++;
    });

    $('.post-type-archive-inthenews').on(
        'click',
        '.newsroom-pagination',
        function () {
            var button = $(this);
            var btnText = button.text();
            button.text('Loading...');

            var str =
                '&pageNumber=' +
                pageNumber +
                '&ppp=10&type=inthenews&action=more_news_ajax';

            $.ajax({
                type: 'POST',
                dataType: 'html',
                url: ajax_posts.ajaxurl,
                data: str,
                beforeSend: function (jqXHR) {
                    button.text('Loading...');
                },
                success: function (data) {
                    if (data) {
                        $(
                            '.inthenewspost-container .grid-inthenewspost'
                        ).append(data);
                        button.text(btnText);
                    } else {
                        button.hide();
                        $('.newsroom-pagination').text('No more posts');
                        console.log('No More Items');
                    }
                },
                afterSend: function (jqXHR) {
                    button.text('More posts').prev().before(data);
                },
                error: function (jqXHR, textStatus, errorThrown) {
                    $loader.html(
                        jqXHR + ' :: ' + textStatus + ' :: ' + errorThrown
                    );
                }
            });
            pageNumber++;
        }
    );

    $('.post-type-archive-newsreleases').on(
        'click',
        '.newsroom-pagination',
        function () {
            var button = $(this);
            var btnText = button.text();
            button.text('Loading...');

            var categoryList = '';
            $('.newsroom-categories-taxonomy input[type=checkbox]').each(
                function () {
                    if (this.checked) {
                        categoryList += $(this).val() + ',';
                    }
                }
            );

            var str =
                '&pageNumber=' +
                pageNumber +
                '&ppp=6&type=newsreleases&action=more_newsreleases_ajax';

            if (categoryList == '') {
                var classList = button.attr('class').split(' ');
                var theType = classList[2].split('-');
                var postType = theType[1];
            } else {
                postType = categoryList;
                console.log('postType: ' + postType);
                var str =
                    '&pageNumber=' +
                    pageNumber +
                    '&ppp=6&type=newsreleases&category=' +
                    postType +
                    '&action=more_taxnewsreleases_ajax';
            }

            $.ajax({
                type: 'POST',
                dataType: 'html',
                url: ajax_posts.ajaxurl,
                data: str,
                beforeSend: function (jqXHR) {
                    button.text('Loading...');
                },
                success: function (data) {
                    if (data) {
                        $('.newsroompost-container .grid-newsroompost').append(
                            data
                        );

                        if (categoryList == '') {
                            $('.newsroom-total span').text(
                                $('.newsroompost').length
                            );
                        } else {
                            $('.newsroom-total span.total--posts').text(
                                $('.newsroompost').length
                            );
                        }

                        button.text(btnText);
                    } else {
                        $('.newsroom-pagination').text('No more posts');
                        console.log('No More Items');
                    }
                },
                afterSend: function (jqXHR) {
                    button.text('More posts').prev().before(data);
                },
                error: function (jqXHR, textStatus, errorThrown) {
                    $loader.html(
                        jqXHR + ' :: ' + textStatus + ' :: ' + errorThrown
                    );
                }
            });
            pageNumber++;
        }
    );

    $('.tax-news-releases-categories').on(
        'click',
        '.newsroom-pagination',
        function () {
            var button = $(this);
            var btnText = button.text();
            button.text('Loading...');

            var categoryList = '';
            $('.newsroom-categories-taxonomy input[type=checkbox]').each(
                function () {
                    if (this.checked) {
                        categoryList += $(this).val() + ',';
                    }
                }
            );
            if (categoryList == '') {
                var classList = button.attr('class').split(' ');
                var theType = classList[2].split('-');
                var postType = theType[1];
            } else {
                postType = categoryList;
            }

            var str =
                '&pageNumber=' +
                pageNumber +
                '&ppp=6&type=newsreleases&category=' +
                postType +
                '&action=more_taxnewsreleases_ajax';

            $.ajax({
                type: 'POST',
                dataType: 'html',
                url: ajax_posts.ajaxurl,
                data: str,
                beforeSend: function (jqXHR) {
                    button.text('Loading...');
                },
                success: function (data) {
                    if (data) {
                        $('.newsroompost-container .grid-newsroompost').append(
                            data
                        );

                        $('.newsroom-total span.total--posts').text(
                            $('.newsroompost').length
                        );

                        button.text(btnText);
                    } else {
                        $('.newsroom-pagination').text('No more posts');
                        console.log('No More Items');
                    }
                },
                afterSend: function (jqXHR) {
                    button.text('More posts').prev().before(data);
                },
                error: function (jqXHR, textStatus, errorThrown) {
                    $loader.html(
                        jqXHR + ' :: ' + textStatus + ' :: ' + errorThrown
                    );
                }
            });
            pageNumber++;
        }
    );

    $('.newsroom-categories-taxonomy').on(
        'click',
        '.filter-checkboxes',
        function () {
            var categoryList = '';
            $('.newsroom-categories-taxonomy input[type=checkbox]').each(
                function () {
                    if (this.checked) {
                        categoryList += $(this).val() + ',';
                    }
                }
            );

            pageNumber = 2;

            var button = $(this);
            var btnText = button.text();
            button.text('Loading...');

            categoryList.slice(0, -1);

            var str =
                '&pageNumber=1&ppp=6&type=newsreleases&category=' +
                categoryList +
                '&action=more_taxnewsreleases_ajax';

            $.ajax({
                type: 'POST',
                dataType: 'html',
                url: ajax_posts.ajaxurl,
                data: str,
                beforeSend: function (jqXHR) {
                    button.text('Loading...');
                },
                success: function (data) {
                    if (data) {
                        $('.newsroompost-container .grid-newsroompost').html(
                            data
                        );
                        $('.newsroom-total span.total--posts').text(
                            $('.newsroompost').length
                        );

                        var the_categories = categoryList.split(',');
                        var list_cats = '';
                        the_categories.forEach((element) => {
                            var newElement = element;
                            if (element.includes('-')) {
                                var arr = element.split('-');
                                newElement = arr.join(' ');
                            }
                            list_cats += newElement + ', ';
                        });
                        var final_list = list_cats.replace(', , ', '');

                        if (
                            !$('.newsroom-total span').hasClass(
                                'post--categories'
                            )
                        ) {
                            $('.newsroom-total').append(
                                '<span class="post--categories"></span>'
                            );
                        }

                        if (final_list == ', ') {
                            $('.newsroom-total span.post--categories').text(
                                'Categories: All'
                            );
                        } else {
                            $('.newsroom-total span.post--categories').text(
                                'Categories: ' + final_list
                            );
                        }

                        button.text(btnText);
                    } else {
                        $('.newsroom-pagination').text('Load more');
                        console.log('No More Items');
                    }
                    $('.newsroom-pagination').text('Load more');
                },
                afterSend: function (jqXHR) {
                    button.text('More posts').prev().before(data);
                },
                error: function (jqXHR, textStatus, errorThrown) {
                    $loader.html(
                        jqXHR + ' :: ' + textStatus + ' :: ' + errorThrown
                    );
                }
            });
        }
    );

    $('.blog').on('click', '.blogs-pagination', function () {
        var button = $(this);
        var btnText = button.text();
        button.text('Loading...');

        var str =
            '&pageNumber=' +
            pageNumber +
            '&ppp=10&type=post&action=more_blogs_ajax';

        //var classList = button.attr('class').split(' ');
        //var theType = classList[2].split('-');
        //var postType = theType[1];

        $.ajax({
            type: 'POST',
            dataType: 'html',
            url: ajax_posts.ajaxurl,
            data: str,
            beforeSend: function (jqXHR) {
                button.text('Loading...');
            },
            success: function (data) {
                if (data) {
                    $('.blogpost-container .grid-blogpost').append(data);

                    //if (categoryList == '') {
                    $('.blog-total span').text($('.blogpost').length);
                    console.log($('.blogpost').length);
                    //} else {
                    //    $('.blog-total span.total--posts').text(
                    //        $('.blogpost').length
                    //    );
                    //}

                    button.text(btnText);
                } else {
                    $('.blogs-pagination').text('No more posts');
                    console.log('No More Items');
                }
            },
            afterSend: function (jqXHR) {
                button.text('More posts').prev().before(data);
            },
            error: function (jqXHR, textStatus, errorThrown) {
                $loader.html(
                    jqXHR + ' :: ' + textStatus + ' :: ' + errorThrown
                );
            }
        });
        pageNumber++;
    });
});
